import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class IsEnableDownloadSales extends PrimitiveValueObject<boolean> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: boolean): IsEnableDownloadSales {
    return new IsEnableDownloadSales(value);
  }
}
